var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCreateRecipeDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0091FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 8.66669C12.5001 8.39054 12.2762 8.16669 12.0001 8.16669C11.7239 8.16669 11.5001 8.39054 11.5001 8.66669H12.5001ZM11.5001 15.3334C11.5001 15.6095 11.7239 15.8334 12.0001 15.8334C12.2762 15.8334 12.5001 15.6095 12.5001 15.3334H11.5001ZM8.66675 11.5C8.39061 11.5 8.16675 11.7239 8.16675 12C8.16675 12.2762 8.39061 12.5 8.66675 12.5V11.5ZM15.3334 12.5C15.6096 12.5 15.8334 12.2762 15.8334 12C15.8334 11.7239 15.6096 11.5 15.3334 11.5V12.5ZM11.5001 8.66669V15.3334H12.5001V8.66669H11.5001ZM8.66675 12.5H15.3334V11.5H8.66675V12.5Z",
    fill: "#FAFBFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCreateRecipeDetail);
export default __webpack_public_path__ + "static/media/plusCreateRecipeDetail.2e21a6fe4f975959e31af5db820ce248.svg";
export { ForwardRef as ReactComponent };